import $ from 'jquery';
import BaseController from 'chairisher/_controller';
import createProductRail from 'chairisher/view/helper/rail';
import ShopAdAnalytics from 'chairisher/view/promotedlistings/shopad';

import { getPromotedListingsUrl } from 'chairisher/context/promotedlistings';
import { ProductRailPosition, ProductRailType } from 'chairisher/util/analytics';

class CollectionListController extends BaseController {
    /** @inheritDoc */
    initControllerState() {
        super.initControllerState();

        this.bindFeaturedNewArrivalsProducts();
        ShopAdAnalytics.initializeShopAdClickListenersAndImpressions();
    }

    /** @inheritDoc * */
    bindFeaturedNewArrivalsProducts() {
        const newArrivalsProductsIdSelector = '#js-new-arrivals-products';
        createProductRail({
            $containerEl: $(newArrivalsProductsIdSelector),
            $el: $(`${newArrivalsProductsIdSelector}-scrollable-grid`),
            analyticsTrackingPosition: ProductRailPosition.BOTTOM,
            analyticsTrackingType: ProductRailType.PROMOTED_LISTINGS,
            listSelector: newArrivalsProductsIdSelector,
            railUrl: getPromotedListingsUrl(),
            sort: 'alt',
        });
    }
}

export default CollectionListController;
